<div class="event-box">
    <span i18n>No Registrations available.</span>
</div>